import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'src/components/tooltips'
import { ButtonIcon } from 'src/components/buttons'
import { LocalizedText } from 'src/components/intl'
import { FormContext } from 'src/contexts'
import { useHandler, useIsFormSubmitting, useIsFormDirty, useIsFormDisabled } from 'src/hooks'
import { UndoIcon } from '../icons'

const UndoButton = ({ title, ...props }) => {
  const form = FormContext.use()
  const submitting = useIsFormSubmitting()
  const dirty = useIsFormDirty()
  const disabled = useIsFormDisabled()

  const onClick = useHandler(() => form.reset())
  const canUndo = !disabled && !submitting && dirty

  return (
    <Tooltip title={title} disabled={!canUndo}>
      <ButtonIcon onClick={onClick} disabled={!canUndo} {...props} />
    </Tooltip>
  )
}

UndoButton.defaultProps = {
  color: 'light',
  icon: UndoIcon,
  title: <LocalizedText id="WEB_CANCEL" />,
  type: 'reset',
}

UndoButton.propTypes = {
  ...ButtonIcon.propTypes,
  title: PropTypes.node,
}

export default UndoButton
